import { styled } from "styled-components";
import DOMPurify from "dompurify";

interface HtmlContentProps {
  html: string;
  as?: "div" | "span";
  className?: string;
  sanitize?: boolean;
}

// Base styling - inherits font/color from parent, provides consistent list styling
const StyledDiv = styled.div`
  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li:before {
      content: "• ";
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

const StyledSpan = styled.span`
  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li:before {
      content: "• ";
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

export const HtmlContent = ({
  html,
  as = "div",
  className,
  sanitize = true,
}: HtmlContentProps) => {
  const sanitizedHtml = sanitize ? DOMPurify.sanitize(html) : html;

  if (as === "span") {
    return (
      <StyledSpan
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  }

  return (
    <StyledDiv
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
